export default __webpack_public_path__ + "static/media/kapolkaBKG.e5cce289.jpg";